import {
  salesContractInitialValues,
  SalesContractProducts,
  salesContractValidationSchema,
} from "./helpers/SalesContractHelper";
import moment from "moment";
import { Formik, Form, FieldArray } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import BasicFields from "./sales-contract-form/BasicFields";
import ActionFields from "./sales-contract-form/ActionFields";
import {
  createSalesContractApi,
  getSaleContractQualitySpecificationSuggestionApi,
  getSalesContractDocumentSuggestionApi,
} from "../../../services/_sales";
import { getBuyerNameListApi } from "../../../services/_buyer";
import { getAllDocumentApi } from "../../../services/_document";
import ProductFields from "./sales-contract-form/ProductFields";
import ShipmentFields from "./sales-contract-form/ShipmentFields";
import DocumentFields from "./sales-contract-form/DocumentFields";
import { getChildProductNameListApi } from "../../../services/_product";
import { errorToast, successToast } from "../../../components/Toast";
import { getAllQualitySpecificationsApi } from "../../../services/_qualitySpecifications";
import QualitySpecificationFields from "./sales-contract-form/QualitySpecificationFields";
import { getAllBrokerApi } from "../../../services/_broker";
import { getAllPackingTypesApi } from "../../../services/_packingTypes";
import AddUnitModal from "../../../components/modal/AddUnit";
import AddPackingType from "../../../components/modal/AddPackingType";
import MarkingFields from "./sales-contract-form/MarkingFields";
import AddBuyerModal from "../../../components/modal/AddBuyer";
import AddBrokerModal from "../../../components/modal/AddBroker";
import AddProductModal from "../../../components/modal/AddProduct";
import AddQualitySpecificationModal from "../../../components/modal/AddQualitySpecification";
import AddDocumentModal from "../../../components/modal/AddDocument";
import BankFields from "./sales-contract-form/BankFields";
import { getAllBankListApi } from "../../../services/_bank";
import { BankType } from "../../../components/Enums";
import AddBankModal from "../../../components/modal/AddBank";
import { getSettingsApi } from "../../../services/_settings";
import GeneralTermsFields from "./sales-contract-form/GeneralTermsFields";
import { getAllGeneralTermsByProductIdApi } from "../../../services/_generalTerms";
import { getAllPortsApi } from "../../../services/_port";
import AddPortModal from "../../../components/modal/AddPort";
import OtherFields from "./sales-contract-form/OtherFields";
import SupplierProducts from "./sales-contract-form/SupplierProducts";
import { getAllPurchasesApi } from "../../../services/_purchase";
import { getSupplierNameListApi } from "../../../services/_supplier";
import { getPermissions } from "../../../context/AuthContext";
import TotalFields from "./sales-contract-form/TotalFields";

interface ProductType {
  id: string;
  name: string;
  variety?: string | null;
  description?: string | null;
  hsn_no?: string | null;
  parent_product_id?: string | null;
}

const CreateSalesContract = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const permissions = getPermissions();
  const [buyerId, setBuyerId] = useState("");
  const [buyerList, setBuyerList] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [productList, setProductList] = useState<ProductType[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [unitList, setUnits] = useState<any[]>([]);
  const [packingType, setPackingType] = useState<any[]>([]);
  const [portList, setPortList] = useState([]);
  const [qualitySpecificationsList, setQualitySpecificationsList] = useState<
    any[]
  >([]);
  const [qltSuggestionList, setQltSuggestionList] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [documentSuggestionList, setDocumentSuggestionList] = useState([]);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [initialValues] = useState<any>(salesContractInitialValues);
  const [addUnitModalStatus, setAddUnitModalStatus] = useState(false);
  const [addPackingTypeModalStatus, setAddPackingTypeModalStatus] =
    useState(false);
  const [filePondFiles, setFilePondFiles] = useState([]);
  const [addBuyerModalStatus, setAddBuyerModalStatus] = useState(false);
  const [addProductModalStatus, setAddProductModalStatus] = useState(false);
  const [addBrokerModalStatus, setAddBrokerModalStatus] = useState(false);
  const [addPortModalStatus, setAddPortModalStatus] = useState(false);
  const [
    addQualitySpecificationModalStatus,
    setAddQualitySpecificationModalStatus,
  ] = useState(false);
  const [addDocumentModalStatus, setAddDocumentModalStatus] = useState(false);
  const [exporterBankList, setExporterBankList] = useState([]);
  const [buyerBankList, setBuyerBankList] = useState([]);
  const [addBankModal, setAddBankModal] = useState(false);
  const [bankType, setBankType] = useState<string>("");
  const [prefix, setPrefix] = useState("");
  const [generalTermsList, setGeneralTermsList] = useState<any[]>([]);
  // const [purchaseOrderList, setPurchaseOrderList] = useState<any[]>([]);
  // const [supplierList, setSupplierList] = useState<any[]>([]);
  // const [supplierProductsQtyData, setSupplierProductsQtyData] = useState<any>(
  //   [],
  // );

  const fetchInitialData = async () => {
    const allBuyers: any = await getBuyerNameListApi(`status=true`);
    if (allBuyers.isSuccess) {
      setBuyerList(allBuyers.data);
    }
    const allBrokers: any = await getAllBrokerApi(`status=true`);
    if (allBrokers.isSuccess) {
      setBrokerList(allBrokers.data);
    }
    const allProducts: any = await getChildProductNameListApi(`status=true`);
    if (allProducts.isSuccess) {
      setProductList(allProducts.data);
    }
    const allPorts: any = await getAllPortsApi(`status=true`);
    if (allPorts.isSuccess) {
      setPortList(allPorts.data);
    }
    // const allQualitySpecs: any = await getAllQualitySpecificationsApi(
    //   `status=true`
    // );
    // if (allQualitySpecs.isSuccess) {
    //   setQualitySpecificationsList(allQualitySpecs.data);
    // }

    // const allGeneralTerms: any = await generalTermsListApi();
    // if (allGeneralTerms.isSuccess) {
    //   setGeneralTermsList(allGeneralTerms);
    // }
    const allDocuments: any = await getAllDocumentApi(`status=true`);
    if (allDocuments.isSuccess) {
      setDocumentList(allDocuments.data);
    }
    // const allUnits: any = await getAllUnitsApi();
    // if (allUnits.isSuccess) {
    //   setUnits(allUnits.data);
    // }

    const fetchSalesContractPrefix: any = await getSettingsApi();
    if (fetchSalesContractPrefix.isSuccess) {
      const { sales_contract_prefix } = fetchSalesContractPrefix.data;
      setPrefix(sales_contract_prefix);
    }
    const allPackingTypes: any = await getAllPackingTypesApi(`status=true`);
    if (allPackingTypes.isSuccess) {
      setPackingType(allPackingTypes.data);
    }
    const allExporterBanks: any = await getAllBankListApi(
      `type=${BankType.EXPORTER}&status=true`,
    );
    if (allExporterBanks.isSuccess) {
      setExporterBankList(allExporterBanks.data);
    }
    // const allPurchaseOrders: any = await getAllPurchasesApi();
    // if (allPurchaseOrders.isSuccess) {
    //   setPurchaseOrderList(allPurchaseOrders.data);
    // }
    // const allSuppliers: any = await getSupplierNameListApi();
    // if (allSuppliers.isSuccess) {
    //   setSupplierList(allSuppliers.data);
    // }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchBuyerBankDetails = async (buyerId: string) => {
    if (buyerId) {
      const allBuyerBanks: any = await getAllBankListApi(
        `type=${BankType.BUYER}&relation_id=${buyerId}&status=true`,
      );
      if (allBuyerBanks.isSuccess) {
        setBuyerBankList(allBuyerBanks.data);
      }
    } else {
      setBuyerBankList([]);
    }
  };

  useEffect(() => {
    fetchBuyerBankDetails(buyerId);
  }, [buyerId]);

  const handleChangeProduct = async (
    updatedProductIds: string[],
    values: any,
    setFieldValue: any,
    oldProductId: any,
    changedIndex?: number,
  ) => {
    if (changedIndex === undefined) return;
    const newProductId =
      values.sales_contract_products[changedIndex]?.product_id;

    const newProduct = productList.find((p: any) => p.id === newProductId);
    const oldProduct = productList.find((p: any) => p.id === oldProductId);

    const newParentId = newProduct?.parent_product_id || newProduct?.id;
    const oldParentId = oldProduct?.parent_product_id || oldProduct?.id;

    if (oldProductId && newParentId !== oldParentId) {
      const resetFields = {
        price: "",
        quantity: "",
        total_amount: "",
        no_of_containers: "",
        container_load: "",
        no_of_bags: "",
        packing_type_id: "",
        packing_net_weight: "",
        total_net_weight: "",
        packing_gross_weight: "",
        total_gross_weight: "",
      };

      Object.entries(resetFields).forEach(([key, value]) => {
        setFieldValue(
          `sales_contract_products.${changedIndex}.${key}`,
          value,
          false,
        );
      });
    }

    // 🔹 STEP 1: Convert child product ids to parent product ids
    const parentProductIds = updatedProductIds
      .map((childId: string) => {
        const product = productList.find((p: ProductType) => p.id === childId);

        return product?.parent_product_id || product?.id;
      })
      .filter(Boolean);

    const uniqueParentIds = Array.from(new Set(parentProductIds));

    // 🔹 STEP 2: Fix filtering of already selected quality specs
    if (
      qualitySpecificationsList.length > 0 &&
      values?.quality_specification?.length > 0
    ) {
      const updatedQualitySpecificationValue =
        values.quality_specification.filter((value: any) => {
          const foundSpecification = qualitySpecificationsList.find(
            (listData: any) => listData.id === value.quality_specification_id,
          );

          return (
            foundSpecification &&
            uniqueParentIds.includes(foundSpecification.product_id)
          );
        });

      setFieldValue("quality_specification", updatedQualitySpecificationValue);
    }

    // 🔹 STEP 3: Fix filtering of general terms
    if (generalTermsList.length > 0 && values?.general_terms?.length > 0) {
      const updatedGeneralTermsValue = values.general_terms.filter(
        (termId: string) => {
          const term = generalTermsList.find(
            (listData: any) => listData.id === termId,
          );

          return term && uniqueParentIds.includes(term.product_id);
        },
      );

      setFieldValue("general_terms", updatedGeneralTermsValue);
    }

    // 🔹 STEP 4: Fetch data using PARENT ids
    if (uniqueParentIds.length > 0) {
      const query = `product_id=[${uniqueParentIds.join(",")}]&status=true`;

      const allQualitySpecs: any = await getAllQualitySpecificationsApi(query);

      setQualitySpecificationsList(
        allQualitySpecs?.isSuccess ? allQualitySpecs?.data || [] : [],
      );

      const qltSuggestion: any =
        await getSaleContractQualitySpecificationSuggestionApi(query);

      setQltSuggestionList(
        qltSuggestion?.isSuccess ? qltSuggestion?.data || [] : [],
      );

      const documentSuggestionList: any =
        await getSalesContractDocumentSuggestionApi(query);

      setDocumentSuggestionList(
        documentSuggestionList?.isSuccess
          ? documentSuggestionList?.data || []
          : [],
      );

      const allGeneralTermsByProductId: any =
        await getAllGeneralTermsByProductIdApi(query);

      setGeneralTermsList(
        allGeneralTermsByProductId?.isSuccess
          ? allGeneralTermsByProductId?.data || []
          : [],
      );
    } else {
      setQualitySpecificationsList([]);
      setQltSuggestionList([]);
      setDocumentSuggestionList([]);
      setGeneralTermsList([]);
    }
  };

  const closeAddUnitModal = () => {
    setAddUnitModalStatus(false);
  };

  const closePackingTypeModal = () => {
    setAddPackingTypeModalStatus(false);
  };

  const closeAddBuyerModal = () => {
    setAddBuyerModalStatus(false);
  };

  const closeAddBrokerModal = () => {
    setAddBrokerModalStatus(false);
  };

  const closeAddProductModal = () => {
    setAddProductModalStatus(false);
  };

  const closeAddPortModal = () => {
    setAddPortModalStatus(false);
  };

  const closeAddQualitySpecificationModal = () => {
    setAddQualitySpecificationModalStatus(false);
  };

  const closeAddDocumentModal = () => {
    setAddDocumentModalStatus(false);
  };

  const openAddBankModal = (isOpen: boolean, type: string) => {
    setBankType(type);
    setAddBankModal(isOpen);
  };

  const closeAddBankModal = () => {
    setAddBankModal(false);
  };

  const handleFileChange = useCallback((fileItems: any, setFieldValue: any) => {
    const files = fileItems
      .map((fileItem: any) => {
        if (fileItem?.file) {
          return {
            fileName: fileItem.file.name,
            fileData: fileItem.getFileEncodeDataURL(),
          };
        }
        return null;
      })
      .filter(Boolean);
    setFieldValue("marking_files", files);
  }, []);

  useEffect(() => {
    if (!id) {
      const initialProduct: SalesContractProducts = {
        product_id: "",
        is_product_variety: false,
        product_variety: "",
        quantity: 0,
        // quantity_unit_id: "",
        price: 0,
        no_of_containers: "",
        container_load: "",
        no_of_bags: "",
        packing_type_id: "",
        packing_net_weight: "",
        total_net_weight: "",
        packing_gross_weight: "",
        total_gross_weight: "",
        // packing_unit_id: "",
        total_amount: "",
      };
      initialValues.sales_contract_products = [initialProduct];
    }
  }, [id, initialValues]);

  const handleSubmit = async (values: any, { resetForm }: any) => {
    values.contract_date = moment(values?.contract_date).format("YYYY-MM-DD");
    values.sub_total = parseFloat(values?.sub_total);
    values.is_digital_signature = values?.is_digital_signature ? true : false;
    setSubmitLoader(true);
    const result: any = await createSalesContractApi(values);
    if (result.isSuccess) {
      setSubmitLoader(false);
      successToast(result.message);
      resetForm({ values: initialValues });
      navigate(`/sales-contract-list`);
    } else {
      setSubmitLoader(false);
      errorToast(result.message);
    }
    return;
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Create Sales Contract</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize
            initialValues={{
              ...initialValues,
              contract_no: prefix || "",
            }}
            validationSchema={salesContractValidationSchema}
            validateOnChange={false} // ✅ disable validation while typing
            validateOnBlur={false} // ✅ disable validation on field blur
            onSubmit={(values, helpers) => {
              handleSubmit(values, helpers);
            }}
          >
            {({
              values,
              handleChange,
              setFieldValue,
              errors,
              touched,
              setFieldError,
            }) => {
              return (
                <Form className="dt_adv_search">
                  <div className="row g-3">
                    <BasicFields
                      buyerList={buyerList}
                      brokerList={brokerList}
                      setBuyerId={setBuyerId}
                      values={values}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      setAddBuyerModalStatus={setAddBuyerModalStatus}
                      setAddBrokerModalStatus={setAddBrokerModalStatus}
                      permissions={permissions}
                    />

                    <div>
                      <label
                        htmlFor="products"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Add Products: <span className="text-danger">*</span>
                      </label>
                      <div>
                        <FieldArray name="sales_contract_products">
                          {({ remove }) => (
                            <>
                              {(values.sales_contract_products ?? []).map(
                                (
                                  item: SalesContractProducts,
                                  index: number,
                                ) => (
                                  <ProductFields
                                    key={index}
                                    index={index}
                                    item={item}
                                    remove={remove}
                                    unitList={unitList}
                                    productList={productList}
                                    packingType={packingType}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    setAddUnitModalStatus={
                                      setAddUnitModalStatus
                                    }
                                    setAddPackingTypeModalStatus={
                                      setAddPackingTypeModalStatus
                                    }
                                    setAddProductModalStatus={
                                      setAddProductModalStatus
                                    }
                                    handleChangeProduct={handleChangeProduct}
                                    errors={errors}
                                    permissions={permissions}
                                  />
                                ),
                              )}

                              <div className="row mb-1 g-1 px- col-12 col-sm-6 col-lg-3">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    const initialProduct: SalesContractProducts =
                                      {
                                        product_id: "",
                                        is_product_variety: false,
                                        product_variety: "",
                                        quantity: 0,
                                        // quantity_unit_id: "",
                                        price: 0,
                                        no_of_containers: "",
                                        container_load: "",
                                        no_of_bags: "",
                                        packing_type_id: "",
                                        packing_net_weight: "",
                                        total_net_weight: "",
                                        packing_gross_weight: "",
                                        total_gross_weight: "",
                                        // packing_unit_id: "",
                                        total_amount: "",
                                      };
                                    const newItems = [
                                      ...values.sales_contract_products,
                                      initialProduct,
                                    ];
                                    setFieldValue(
                                      "sales_contract_products",
                                      newItems,
                                    );
                                  }}
                                >
                                  Add Product
                                </button>
                              </div>
                            </>
                          )}
                        </FieldArray>

                        {errors.sales_contract_products &&
                          touched.sales_contract_products &&
                          typeof errors.sales_contract_products ===
                            "string" && (
                            <div className="text-danger">
                              {errors.sales_contract_products}
                            </div>
                          )}
                      </div>
                    </div>

                    <TotalFields values={values} handleChange={handleChange} />

                    <MarkingFields
                      actionType={"create"}
                      values={values}
                      handleChange={handleChange}
                      filePondFiles={filePondFiles}
                      setFilePondFiles={setFilePondFiles}
                      handleFileChange={handleFileChange}
                      setFieldValue={setFieldValue}
                    />

                    <ShipmentFields
                      portList={portList}
                      values={values}
                      setAddPortModalStatus={setAddPortModalStatus}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      permissions={permissions}
                    />

                    <QualitySpecificationFields
                      values={values}
                      setAddQualitySpecificationModalStatus={
                        setAddQualitySpecificationModalStatus
                      }
                      qualitySpecificationsList={qualitySpecificationsList}
                      qltSuggestionList={qltSuggestionList}
                      setFieldValue={setFieldValue}
                      permissions={permissions}
                    />

                    <DocumentFields
                      values={values}
                      setAddDocumentModalStatus={setAddDocumentModalStatus}
                      documentList={documentList}
                      documentSuggestionList={documentSuggestionList}
                      setFieldValue={setFieldValue}
                      permissions={permissions}
                    />

                    {/* <SupplierProducts
                      values={values}
                      productList={productList}
                      purchaseOrderList={purchaseOrderList}
                      supplierList={supplierList}
                      supplierProductsQtyData={supplierProductsQtyData}
                      setSupplierProductsQtyData={setSupplierProductsQtyData}
                      unitList={unitList}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      errors={errors}
                    /> */}

                    <BankFields
                      exporterBankList={exporterBankList}
                      buyerBankList={buyerBankList}
                      openAddBankModal={openAddBankModal}
                      values={values}
                      handleChange={handleChange}
                      permissions={permissions}
                    />

                    <GeneralTermsFields
                      values={values}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      generalTermsList={generalTermsList}
                    />

                    <OtherFields
                      values={values}
                      setFieldValue={setFieldValue}
                    />

                    <ActionFields submitLoader={submitLoader} />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
      <AddUnitModal
        addUnitModalStatus={addUnitModalStatus}
        closeAddUnitModal={closeAddUnitModal}
        onUnitCreated={fetchInitialData}
      />
      <AddPackingType
        addPackingTypeModalStatus={addPackingTypeModalStatus}
        closePackingTypeModal={closePackingTypeModal}
        onPackingTypeCreated={fetchInitialData}
      />
      <AddBuyerModal
        addBuyerModal={addBuyerModalStatus}
        closeAddBuyerModal={closeAddBuyerModal}
        onBuyerCreated={fetchInitialData}
      />
      <AddBrokerModal
        addBrokerModal={addBrokerModalStatus}
        closeAddBrokerModal={closeAddBrokerModal}
        onBrokerCreated={fetchInitialData}
      />
      <AddProductModal
        addProductModalStatus={addProductModalStatus}
        closeAddProductModal={closeAddProductModal}
        onProductCreated={fetchInitialData}
      />
      <AddPortModal
        addPortModal={addPortModalStatus}
        closeAddPortModal={closeAddPortModal}
        onPortCreated={fetchInitialData}
      />
      <AddQualitySpecificationModal
        addQualitySpecificationModal={addQualitySpecificationModalStatus}
        closeAddQualitySpecificationModal={closeAddQualitySpecificationModal}
        onQualitySpecificationCreated={fetchInitialData}
      />
      <AddDocumentModal
        addDocumentModal={addDocumentModalStatus}
        closeAddDocumentModal={closeAddDocumentModal}
        onDocumentCreated={fetchInitialData}
      />
      <AddBankModal
        addBankModal={addBankModal}
        closeAddBankModal={closeAddBankModal}
        onBankCreated={() => {
          fetchBuyerBankDetails(buyerId);
          fetchInitialData();
        }}
        type={bankType}
        selectedBuyerId={buyerId}
      />
    </>
  );
};

export default CreateSalesContract;
